<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props">
    <template #title>
      <span>
        <span :class="styles.title">{{ menuInfo.title }}</span>
        <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
        <template v-if="menuInfo.icon">
          <component
            v-if="isIconComponent"
            :is="menuInfo.icon"
            :class="styles.icon"
            :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
          />
          <img
            v-else-if="isIconImage"
            :src="menuInfo.icon"
            :class="styles.icon"
            :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
          />
          <i
            v-else
            :class="[styles.icon, menuInfo.icon]"
            :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
          />
        </template>
      </span>
    </template>
    <template v-for="item in menuInfo.children">
      <template v-if="!item.roles || item.roles.includes(user.role)">
        <item
          v-if="!item.children && !item.divider"
          :key="item.key"
          :menu-info="item"
          :styles="styles"
        />
        <sub-menu v-if="item.children" :key="item.key" :menu-info="item" :styles="styles" />
      </template>
    </template>
  </a-sub-menu>
</template>

<script>
import { Menu } from 'ant-design-vue'
import Item from './item'
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  name: 'SubMenu',
  components: { Item },
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: {
      type: Object,
      default: () => {},
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const store = useStore()
    const settings = computed(() => store.getters.settings)
    const user = computed(() => store.getters['user/user'])

    const isIconImage = computed(() => {
      const icon = props.menuInfo.icon
      return (
        typeof icon === 'string' &&
        (icon.includes('/') || icon.includes('http') || icon.startsWith('data:'))
      )
    })

    const isIconComponent = computed(() => {
      const icon = props.menuInfo.icon
      return icon && (typeof icon === 'object' || typeof icon === 'function')
    })

    return {
      settings,
      user,
      isIconImage,
      isIconComponent,
    }
  },
}
</script>
